import animales  from './animales.json'; 
import will from './will.json';
import willDecisions from './willdecisions.json';
import might from './might.json';
import should from './should.json';
import could from './could.json';
import household from './household.json';
import presentPerfect from './presentperfect.json';
import PresentvsPast from './perfectvssimple.json';
import yetvsalready from './yetvsalready.json';
import restaurants from './restaurant.json';
import plans from './plans.json';
import questionsTags from './questiontags.json';
import countries from './countries.json';
import prepOfPlace from './prepofplace.json';
import numeros from './numeros.json';
import horas from './horas.json';
import contacto from './contacto.json';

export const GRAMMAR_M6 = [
  ...animales,
  ...will,
  ...willDecisions,
  ...might,
  ...should,
  ...could,
  ...household,
  ...presentPerfect,
  ...PresentvsPast,
  ...yetvsalready,
  ...restaurants,
  ...plans,
  ...questionsTags,
  ...countries,
  ...prepOfPlace,
  ...numeros,
  ...horas,
  ...contacto
];